export const CLIENT_IMAGE_META_ANALYSIS_VERSION = 1 as const;
export const CLIENT_IMAGE_META_FIELDS = [
  'width',
  'height',
  'format',
  'hasTransparentPixels',
] as const;

// 白名单能力：客户端获取的宽度、高度、格式和透明度可以直接作为运行依据。
// 这里是元数据字段级白名单，不是某个 Tool 的特判；未列出的字段不得走客户端直信任路径。
export const CLIENT_IMAGE_META_DIRECT_TRUST_FIELDS = [
  'width',
  'height',
  'format',
  'hasTransparentPixels',
] as const;

export type ClientImageMetaDirectTrustField =
  (typeof CLIENT_IMAGE_META_DIRECT_TRUST_FIELDS)[number];

export function isClientImageMetaDirectTrustField(
  field: (typeof CLIENT_IMAGE_META_FIELDS)[number]
): field is ClientImageMetaDirectTrustField {
  return CLIENT_IMAGE_META_DIRECT_TRUST_FIELDS.includes(
    field as ClientImageMetaDirectTrustField
  );
}
